import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "designSystem/components/button/IconButton";
import { ComponentItem } from "designSystem/types/component-item-types";
import { GridColumn, GridRow, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewReportStore } from "./CustomViewReportStore";

interface CustomViewCalculationItemProps {
	/** the index of this level */
	index: number;
}

const CustomViewCalculationItem: FunctionComponent<CustomViewCalculationItemProps> = observer((props) => {
	const {
		index,
	} = props;

	const {
		calculationList,
		functions,
		getOptions,
		options,
		removeCalculationItem,
		setCalculationItem,
		weightedAverageOptions,
	} = useCustomViewReportStore();

	const {
		calculationFunction,
		item,
		setCalculationItemCalculationFunction,
		setCalculationItemWeightedAverageItem,
		visible,
		weightedAverageItem,
	} = calculationList[index];

	return (
		<GridColumn spacingAroundY={2}>
			{options && (
				<GridRow
					data-csi-automation="CustomViewCalculationItem"
					grow
					growChild={0}
					spacingAroundX={1}
					spacingAroundY={2}
				>
					<GridRow
						growAllChildren
					>
						<SingleSelect
							disableClearable
							forcePopupIcon
							groupBy={(option) => option.group}
							onChange={(event, value, reason) => setCalculationItem(value as ComponentItem, index)}
							options={getOptions(item)}
							value={item}
						/>
						<SingleSelect
							fullWidth
							onChange={(event, newValueItem, reason) => setCalculationItemCalculationFunction(newValueItem as ComponentItem)}
							options={functions}
							required
							value={calculationFunction}
						/>
						<SingleSelect
							fullWidth
							onChange={(event, newValueItem, reason) => setCalculationItemWeightedAverageItem(newValueItem as ComponentItem)}
							options={weightedAverageOptions(item.id)}
							required
							sx={{ visibility: visible }}
							value={weightedAverageItem}
						/>
					</GridRow>
					<GridRow>
						<IconButton onClick={() => removeCalculationItem(index)} size="large">
							<ClearIcon />
						</IconButton>
					</GridRow>
				</GridRow>
			)}
		</GridColumn>
	);
});

export default CustomViewCalculationItem;